import React, { useState } from 'react';
import { Save, Plus, Trash2 } from 'lucide-react';
import { apiCall, useAdminData, ImageUploader } from './_helpers';

const GalleryManager = ({ onMessage }) => {
  const [items, setItems, refetch] = useAdminData('gallery');
  const [creating, setCreating] = useState(null);

  const handleSave = async () => {
    try { await apiCall('POST', 'gallery', creating); onMessage('success', 'Saved'); setCreating(null); refetch(); }
    catch (e) { onMessage('error', e.message); }
  };
  const handleDelete = async (id) => {
    if (!window.confirm('Delete this image?')) return;
    try { await apiCall('DELETE', `gallery/${id}`); onMessage('success', 'Deleted'); refetch(); }
    catch (e) { onMessage('error', e.message); }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Gallery Images</h2>
        <button onClick={() => setCreating({ url: '', alt: '', caption: '', order: items.length, is_active: true })}
          className="bg-[#C9A86C] text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-[#B8956A]">
          <Plus size={18} /> Add Image
        </button>
      </div>

      {creating && (
        <div className="bg-white rounded-xl p-6 shadow-md mb-6">
          <div className="space-y-3">
            <ImageUploader currentImage={creating.url} onUpload={(url) => setCreating({ ...creating, url })} />
            <input type="text" placeholder="Image URL" value={creating.url} onChange={(e) => setCreating({ ...creating, url: e.target.value })} className="w-full border rounded-lg px-4 py-2" />
            <input type="text" placeholder="Alt text" value={creating.alt} onChange={(e) => setCreating({ ...creating, alt: e.target.value })} className="w-full border rounded-lg px-4 py-2" />
            <input type="text" placeholder="Caption" value={creating.caption} onChange={(e) => setCreating({ ...creating, caption: e.target.value })} className="w-full border rounded-lg px-4 py-2" />
          </div>
          <div className="flex gap-2 mt-4">
            <button onClick={handleSave} className="bg-green-600 text-white px-4 py-2 rounded-lg flex items-center gap-2"><Save size={18} /> Save</button>
            <button onClick={() => setCreating(null)} className="bg-gray-500 text-white px-4 py-2 rounded-lg">Cancel</button>
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((img) => (
          <div key={img._id} className="bg-white rounded-xl overflow-hidden shadow-md">
            <img src={img.url} alt={img.alt} className="w-full h-48 object-cover" />
            <div className="p-4">
              <p className="font-semibold">{img.caption}</p>
              <p className="text-gray-500 text-sm">{img.alt}</p>
              <button onClick={() => handleDelete(img._id)} className="text-red-600 hover:bg-red-50 p-2 rounded mt-2"><Trash2 size={18} /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GalleryManager;
